var _path, _path2, _path3, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMypageLive = function SvgMypageLive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD167",
    fillRule: "evenodd",
    d: "M9.75 22.5H18a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 18 4.5H9.75A2.25 2.25 0 0 0 7.5 6.75v13.5a2.25 2.25 0 0 0 2.25 2.25",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540E",
    fillRule: "evenodd",
    d: "M15 19.5a1.125 1.125 0 1 1-2.249.001A1.125 1.125 0 0 1 15 19.5M10.546 1.5A6.804 6.804 0 0 0 3.75 8.296a6.804 6.804 0 0 0 6.796 6.796h5.203v-2.435a6.78 6.78 0 0 0 1.592-4.361A6.804 6.804 0 0 0 10.547 1.5",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.353 9.348v.63H6.42v-3.34h.659v2.71z",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mypage-live_svg__a",
    width: 18,
    height: 22,
    x: 3,
    y: 1,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.75 22.5h16.5v-21H3.75z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#mypage-live_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.699 9.978h.614V7.592h-.615zm-.072-3.05c0-.205.171-.381.377-.381.21 0 .382.176.382.381a.38.38 0 0 1-.382.377.38.38 0 0 1-.377-.377M12.125 7.592l-.906 2.386h-.702L9.61 7.592h.678l.577 1.67.583-1.67zM14.055 8.56a.58.58 0 0 0-.592-.482c-.33 0-.553.177-.625.482zm-.534.926c.237 0 .429-.1.534-.238l.496.286c-.224.324-.582.51-1.04.51-.802 0-1.308-.548-1.308-1.26 0-.71.51-1.26 1.26-1.26.707 0 1.208.56 1.208 1.26 0 .091-.01.172-.024.254h-1.8c.086.315.349.448.674.448"
  }))));
};
export default SvgMypageLive;